<template>
    <a-spin :tip="$t('Loading...')" :spinning="getting_data">
        <navbar :back_path="back_path || '/activity'" :navbar_sub_visible="$device != 'mobile'" active_screen="รายละเอียดกิจกรรม" :content_title="ticket_data.title" :hide_search="true" />
        <div :class="`main-content is-${$device} ml-20 mr-20 mb-20 mt-20`">
            <!-- <div class="row justify-content-center">
                <span class="fs-20 black fw-600" style="display: block"> {{ $t('รายละเอียดกิจกรรม') }} </span>
            </div> -->
            <div class="row justify-content-center">
                <span class="fs-20 black fw-600 red" style="display: block"> {{ ticket_data.title }} </span>
            </div>
            <iframe :src="pdf_url" style="width: 100%; height: 100vh" class="br-12">Oops! an error has occurred. </iframe>
            <div class="row" style="margin-top: 14px">
                <div class="col-12">
                    <a-button size="large" class="text-center primary-btn ant-button-label-custom w-100" :loading="loading" @click="onShare">
                        <i class="fa fa-share-alt" aria-hidden="true"></i><strong class="fs-18">&nbsp;{{ $t('คัดลอกลิงก์') }}</strong>
                    </a-button>
                </div>
            </div>
        </div>
        <modal-form :visible="modal_visible" :data="modal_data" :step="modal_step" @on-cancel="onModalCancel" />
        <div v-if="$device != 'mobile'" class="copyright-section-space"></div>
        <div v-if="$device != 'mobile'" class="copyright-section">© Copyright SCG Debenture Club. All Rights Reserved.</div>
    </a-spin>
</template>
<script>
import moment from 'moment';
import navbar from '../../components/navbar';
import _ from 'lodash';
import modalForm from './modalForm';
export default {
    components: {
        navbar,
        modalForm,
    },
    data: function () {
        return {
            modal_visible: false,
            modal_step: '',
            modal_data: {},
            activity_detail: {
                title: 'คอนเสริต์มหัศจรรย์ รักไม่รู้จบ',
            },
            getting_data: false,
            back_path: this.$route.query.back_path,
            pdfUrl: 'https://www.orimi.com/pdf-test.pdf',
            act_id: this.$route.query.act_id,
            items: [],
            apply_id: this.$route.query.apply_id,
            ticket_data: {},
            columns_data: [],
            label: this.$route.query.label,
            pdf_url: this.$route.query.pdf_url,
        };
    },
    computed: {
        columns() {
            const arr = _.clone(this.items);
            console.log('arr', arr);
            const columns = [];
            while (arr.length) columns.push(arr.splice(0, 2));
            console.log('columns', columns);
            return columns;
        },
    },
    mounted() {
        this._mounted();
    },
    methods: {
        moment,
        _mounted: function () {
            this.getActivityDetail(() => (this.getting_data = false));
        },
        getActivityDetail: function (callback = null) {
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/log/activity/detail',
                    data: {
                        apply_id: this.apply_id,
                    },
                    callback: (res) => {
                        if (res && res.result == 'errors') {
                            const error = {
                                title: '',
                            };
                            for (const [key, value] of Object.entries(res.errors)) {
                                console.log('value', value);
                                if (key) {
                                    error.title = value[0];
                                }
                            }
                            this.$confirm({
                                title: error.title,
                                button: {
                                    yes: 'ปิดหน้าต่าง',
                                },
                                callback: (confirm) => {},
                            });
                        } else {
                            this.ticket_data = res;
                            console.log('this.ticket_data--------------->', this.ticket_data);
                            this.items = _.clone(this.ticket_data.ticket_data.doc_list);
                            // this.columns_data[0] = [];
                            // this.columns_data[1] = [];
                            // while (arr.length) {
                            //     this.columns_data[0].push(arr.splice(0, 1)[0]);
                            //     this.columns_data[1].push(arr.splice(0, 1)[0]);
                            // }
                        }
                        if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        handlePageChange(page) {
            console.log('handlePageChange page -->', page);
        },
        toMoment(date_unix, format) {
            return this.mtby(moment.unix(date_unix), format);
        },
        size(v) {
            return _.size(v);
        },
        get(v1, v2, v3) {
            return _.get(v1, v2, v3);
        },
        async onShare(textToCopy = this.pdf_url) {
            try {
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(textToCopy);
                    // this.$alert(null, 'คัดลอกสำเร็จ!', null, {
                    //     confirmButtonText: 'OK',
                    //     customClass: 'normal-alert-ok-btn',
                    // });
                    this.modal_visible = true;
                    this.modal_step = 'custom_with_header';
                    this.modal_data.title = 'คัดลอกสำเร็จ';
                } else {
                    const textArea = document.createElement('textarea');
                    textArea.value = textToCopy;
                    textArea.style.position = 'fixed';
                    textArea.style.left = '-999999px';
                    textArea.style.top = '-999999px';
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    return new Promise((resolve) => {
                        if (document.execCommand('copy')) {
                            // this.$alert(null, 'คัดลอกสำเร็จ!', null, {
                            //     confirmButtonText: 'OK',
                            //     customClass: 'normal-alert-ok-btn',
                            // });
                            this.modal_visible = true;
                            this.modal_step = 'custom_with_header';
                            this.modal_data.title = 'คัดลอกสำเร็จ';
                            resolve();
                        }
                        textArea.remove();
                    });
                }
            } catch (e) {
                // this.$alert(null, 'คัดลอกไม่สำเร็จ!', null, {
                //     confirmButtonText: 'OK',
                //     customClass: 'normal-alert-ok-btn',
                // });
                this.modal_visible = true;
                this.modal_step = 'custom_with_header';
                this.modal_data.title = 'คัดลอกไม่สำเร็จ!';
            }
        },
        onModalCancel() {
            this.modal_visible = false;
            this.modal_step = null;
            this.modal_data = {};
        },
    },
};
</script>
<style scoped>
.main-content {
    /* background-color: #fff; */
    /* width: 100vw; */
    /* padding: 14px; */
    min-height: 100vh;
}
.main-content.is-tablet.step-register_success {
    margin-top: 15vh;
}
.badge-icon {
    position: absolute;
    top: 3px;
    right: 200px;
    background: url('../../../public/resources/images/follower-badge.png');
    background-size: 100%;
    width: 40px;
    height: 40px;
}
.badge-icon-new {
    top: 3px;
    right: 200px;
    background: url('../../../public/resources/images/follower-badge.png');
    background-size: 100%;
    width: 40px;
    height: 40px;
    margin: 4px;
}
.badge-label {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    color: #000 !important;
    line-height: 40px;
    font-size: 14px;
}
.custom-card {
    margin: 16px;
    background-color: #fff;
    border-radius: 8px;
}
.custom-close {
    font-size: 16px;
    font-weight: 300;
    margin: 0;
    color: #707070 !important;
    text-align: right;
    opacity: 0.5;
}
.slide {
    background-color: transparent;
    width: 100%;
    text-align: center;
    padding-top: 48px;
}
.VueCarousel {
    margin-top: -10px !important;
}
.title {
    font-size: 20px;
    font-weight: 600;
    margin: 8px 0 0 16px;
    color: #cc0000 !important;
}
.description {
    font-size: 16px;
    font-weight: 300;
    margin: 0 16px;
    color: #000 !important;
}
.description-read-all {
    font-size: 16px;
    font-weight: 300;
    margin: 0 16px;
    color: #000 !important;
}
.read-all {
    font-size: 14px;
    font-weight: 300;
    margin: 8px 0 8px 0;
    color: #707070 !important;
}
.half-circle {
    width: 50px;
    height: 25px; /* as the half of the width */
    background-color: #fff;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    /* border: 10px solid gray; */
    border-top: 0;
    box-shadow: #707070 0px 25px 40px 0px;
    margin: 0 auto;
}
/* .vue-confirm-dialog {
}
.vue-confirm-dialog .vc-container .vc-text-grid .vc-title {
  font-size: 16px !important;
}
.vc-title {
  font-size: 16px !important;
} */
.กางได้ {
    width: 90%;
    min-height: 64px;
    line-height: 64px;
    background: linear-gradient(0deg, #af2e30, #e05a61 100%) no-repeat;
    margin: 8px auto;
    color: #fff;
    font-weight: 300;
    padding: 0 16px;
}
.custom-container {
    display: flex;
    /* border: 1px solid; */
    min-height: 100vh;
}
.col {
    margin: 10px;
    border: 1px solid;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}
.custom-container-item {
    /* border: 1px solid; */
    padding: 14px;
    margin: 14px;
    text-align: center;
    border-radius: 14px;
}
</style>
